import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import { MetaVentaSeguros } from '../_models/meta-venta-seguros';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MetaVentaSegurosService {

  private rutServicios = AppSettings.rutServiciosAPL + '/api/metaVentaSeguros/';

  constructor( private httpClient: HttpClient, private autenticacionService: AutenticacionService ) {
  }

  listado(): Observable<MetaVentaSeguros[]> {
    return this.httpClient.get( this.rutServicios ).pipe( map( res => res as MetaVentaSeguros[] ) );
  }

  obtener( idMeta: string ): Observable<MetaVentaSeguros> {
    return this.httpClient.get( this.rutServicios + idMeta ).pipe( map( res => res as MetaVentaSeguros ) );
  }

  agregar( meta: MetaVentaSeguros ): Observable<MetaVentaSeguros> {
    meta.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    meta.auditoriaFecha = new Date( Date.now() );
    return this.httpClient.post( this.rutServicios, meta ).pipe( map( res => res as MetaVentaSeguros ) );
  }

  actualizar( meta: MetaVentaSeguros ): Observable<any> {
    return this.httpClient.put( this.rutServicios, meta ).pipe( map( res => res as any ) );
  }
}
